export var attachStyleToHTML = function (textContent) {
    var style = document.createElement('style');
    style.textContent = textContent;
    document.head.appendChild(style);
};
